import useLang from "../../hooks/useLang";

const useNotesBlock = (assessment) => {
  const lang = useLang();

  const notesKeys =
    assessment?.data?.notes != null ? Object.keys(assessment?.data?.notes) : [];
  const notesList = notesKeys
    ?.filter(
      (item) => item !== "selectivity_left" && item !== "selectivity_right"
    )
    ?.map((noteKey) => assessment?.data?.notes[noteKey])
    ?.filter((note) => note != null && note !== "");

  const notesArticle =
    Array.isArray(notesList) && notesList.length > 0
      ? {
          header: {
            title: lang("captions.notes"),
          },
          items: {
            id: "notes",
            data: notesList,
            type: "list",
          },
        }
      : null;

  return notesArticle;
};

export default useNotesBlock;
